module.exports = __webpack_public_path__ + "static/media/settings.8d4290fe.webp";